import { useEffect } from 'react';
import { useContextAwareGetModuleTypes } from '@app/hooks/useGenericOperationsHooks';
import { ModuleTypeRegistry } from './moduleTypeRegistry';
import { ModuleType } from '@typedefs/interfaces';

export const useModuleTypeRegistry = () => {
  const { data: moduleTypes, isLoading, error } = useContextAwareGetModuleTypes({});

  useEffect(() => {
    if (moduleTypes) {
      ModuleTypeRegistry.getInstance().initialize(moduleTypes as ModuleType[]);
    }
  }, [moduleTypes]);

  return {
    moduleTypes: moduleTypes as ModuleType[],
    isLoading,
    error,
    registry: ModuleTypeRegistry.getInstance()
  };
};